import React from 'react';
import _ from "lodash";
import ApiSelect from "../../base/components/forms/apiSelect";
import {useController} from "react-hook-form";
import FormHookInput from "../../air/airBooking/components/formHookInput";

const GroupFormItem = ({item, prefix, formController, removeItem}) => {
  const {register,
    formState:{errors},
    setValue,
    getValues,
    control} = formController
  const {
    field: { onChange: counterpartyOnChange, value: counterpartyValue }
  } = useController({
    name: `${prefix}.counterparty`,
    control,
    rules: { required: true },
    defaultValue: item.counterparty
  });
  return (
      <div className={'d-flex justify-content-between align-items-center gap-2 p-3'}>
        <div className={'d-flex gap-2 align-items-center'}>
          <div style={{width: 200}}>
            <ApiSelect
              value={counterpartyValue}
              label={'Покупатель'}
              hasError={_.get(errors, `${prefix}.counterparty`)}
              url={"/api/counterparty/searchInput"}
              cb={newVal => {
                counterpartyOnChange(newVal);
              }}
              getLabel={(v) => {
                if(_.get(getValues(), `${prefix}.clientName`) === '') {
                  setValue(`${prefix}.clientName`, v)
                }
                if(_.get(getValues(), `${prefix}.cashName`) === '') {
                  setValue(`${prefix}.cashName`, v)
                }
              }}
            />
          </div>

          <FormHookInput
            register={register(`${prefix}.clientName`, {required: true})}
            label={'Клиентское имя'}
            errors={errors}
          />
          <FormHookInput
            register={register(`${prefix}.cashName`, {required: true})}
            label={'Имя в кассе'}
            errors={errors}
          />
          <FormHookInput
            register={register(`${prefix}.startSaldo`)}
            label={'Сальда нач.'}
            type={'number'}
            errors={errors}
          />
        </div>
        <i className={"fa fa-trash text-danger pointer"} onClick={removeItem}/>


      </div>
  );
};

export default GroupFormItem;
